import capitalize from "lodash/capitalize";
import { DEFAULT_AXIS_KEY } from "views/components/visualizations/Constants";
import AxisVisualizationField from "views/components/aggregationwizard/visualization/configurationFields/AxisVisualizationField";
export const getNumericAxisMetrics = (values) => {
  var _a, _b;
  const units = (_a = values == null ? void 0 : values.units) != null ? _a : {};
  const metrics = (_b = values == null ? void 0 : values.metrics) != null ? _b : [];
  return metrics.filter(({ field, function: metricFn }) => {
    var _a2, _b2;
    return !(((_a2 = units == null ? void 0 : units[field]) == null ? void 0 : _a2.unitType) && ((_b2 = units == null ? void 0 : units[field]) == null ? void 0 : _b2.abbrev)) && metricFn;
  }).map((metric) => {
    var _a2;
    return metric.name || `${metric.function}(${(_a2 = metric.field) != null ? _a2 : ""})`;
  });
};
export const getAxisMetrics = (unitType, values) => {
  var _a, _b;
  const units = (_a = values == null ? void 0 : values.units) != null ? _a : {};
  const metrics = (_b = values == null ? void 0 : values.metrics) != null ? _b : [];
  const unitTypeFields = new Set(
    Object.entries(units).filter(([_, unit]) => unit.unitType === unitType && unit.abbrev).map(([field]) => field)
  );
  return metrics.filter(({ field, function: metricFn }) => unitTypeFields.has(field) && metricFn).map((metric) => {
    var _a2;
    return metric.name || `${metric.function}(${(_a2 = metric.field) != null ? _a2 : ""})`;
  });
};
const getUnitTypeFields = () => ["percent", "time", "size"].map((unitType) => ({
  name: `axisConfig.${unitType}`,
  title: `Y-${capitalize(unitType)}`,
  id: unitType,
  type: "custom",
  component: AxisVisualizationField,
  isShown: (formValues, widgetConfigFormValues) => formValues.showAxisLabels && !!getAxisMetrics(unitType, widgetConfigFormValues).length,
  inputHelp: (_, widgetConfigFormValues) => getAxisMetrics(unitType, widgetConfigFormValues).join(", ")
}));
export const fromAxisConfig = (config) => {
  var _a;
  return {
    showAxisLabels: Object.values((_a = config == null ? void 0 : config.axisConfig) != null ? _a : {}).some(({ title }) => !!title),
    axisConfig: config == null ? void 0 : config.axisConfig
  };
};
const xyAxisConfigFields = [
  {
    name: "showAxisLabels",
    title: "Show axis labels",
    type: "boolean"
  },
  {
    name: "axisConfig.xaxis",
    title: "X-axis",
    type: "custom",
    id: "xaxis",
    component: AxisVisualizationField,
    isShown: (formValues) => formValues.showAxisLabels
  },
  {
    name: `axisConfig.${DEFAULT_AXIS_KEY}`,
    title: "Y-Number",
    type: "custom",
    id: "number",
    component: AxisVisualizationField,
    isShown: (formValues, widgetConfigFormValues) => !!getNumericAxisMetrics(widgetConfigFormValues).length && formValues.showAxisLabels,
    inputHelp: (_, widgetConfigFormValues) => getNumericAxisMetrics(widgetConfigFormValues).join(", ")
  },
  ...getUnitTypeFields()
];
export default xyAxisConfigFields;
